import React from 'react';
import { Link } from 'react-router-dom';

interface DynamicLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {}

export default function DynamicLink(props: DynamicLinkProps) {
  const { href, ...rest } = props;

  if (href && (href.startsWith('http://') || href.startsWith('https://'))) {
    return <a href={href} {...rest} />;
  }

  return <Link to={href ?? ''} {...rest} />;
}